import React from 'react';
import { Link } from 'react-router-dom';

const GpAddressExplainer = () => (
  <>
    <h1>Your registered address</h1>
    <p>This is the address that was registered with your GP surgery when you set up your Hey Pharmacist account.</p>
    <p>You cannot edit or delete this on the Hey Pharmacist website.</p>
    <p>
      If you want to get your medication delivered to a different address, you can{' '}
      <Link to="/pharmacy/dashboard/account/address/postcode">add a new address.</Link>
    </p>
    <p>
      If you want to tell your GP surgery that you’ve changed address, contact them directly. This will not update
      automatically on the site.
    </p>
  </>
);

export default GpAddressExplainer;
